import { render, staticRenderFns } from "./Mentor.vue?vue&type=template&id=161b172c&scoped=true"
import script from "./Mentor.vue?vue&type=script&lang=js"
export * from "./Mentor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161b172c",
  null
  
)

export default component.exports